import './handlers';
import MarketStatisticsHolder from '@/market-statistics/views/MarketStatistics';
export default MarketStatisticsHolder;
